import { ClaimTypeIconLabel } from '../components/claimTypeDropdown/ClaimTypeIconLabel';
import { ClaimType } from 'all-in-one-shared-api';
import { ClaimTypesEnum } from './ClaimTypesEnum';
import { ENGLISH_SYMBOL } from 'i18n';
import i18n from 'i18n';

export const CLAIM_TYPE_ALL_OP = 'all__OP';
export const getTreeOptions = (options: ClaimType[], language: string) => {
  return options.map(({ code, description, chineseDescription, benefits }) => {
    let children = benefits?.map(
      ({ code: subCode, description: subDescription, chineseDescription: subChineseDescription }) => ({
        title: language === ENGLISH_SYMBOL ? subDescription : subChineseDescription,
        key: `${code}__${subCode}`,
        value: `${code}__${subCode}`,
      }),
    );
    if (code === ClaimTypesEnum.OP && children && benefits) {
      const option = {
        value: `${CLAIM_TYPE_ALL_OP}`,
        title: i18n.t('claims.allTypesOP'),
        key: `${CLAIM_TYPE_ALL_OP}`,
      };
      children = [option, ...children];
    }

    return {
      title: ClaimTypeIconLabel(
        (language === ENGLISH_SYMBOL ? description : chineseDescription) || '',
        code as ClaimTypesEnum,
      ),
      key: code,
      value: code,
      checkable: !children,
      children,
    };
  });
};
